import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class Materials_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public Materials: Materials_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

